import React, { useState, useEffect } from 'react';
import FAQ from '../../../components/FAQ';
import { useToast } from '../../../contexts/ToastContext';
import { fetchFaqs } from '../../../api/faqApi';

function FAQSection() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const { addToast } = useToast();

  useEffect(() => {
    const fetchFaqsData = async () => {
      try {
        setLoading(true);
        const data = await fetchFaqs({ limit: 6, paginate: false });

        if (data.success) {
          const formattedFaqs = data.data.map(faq => ({
            id: faq.id,
            question: faq.question,
            answer: faq.answer,
          }));
          setFaqs(formattedFaqs);
        } else {
          addToast('error', data.message || 'Failed to fetch FAQs.');
        }
      } catch (e) {
        console.error("Error fetching FAQs:", e);
        addToast('error', 'Failed to load FAQs. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchFaqsData();
  }, [addToast]);

  // If no FAQs and not loading, return null to hide the section
  if (!loading && faqs.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-bg-dark text-text-gray">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-4xl font-bold text-center text-text-white relative after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-20 after:h-1 after:bg-accent-red after:rounded-sm after:bottom-[-15px] mb-12">
          Frequently Asked Questions
        </h2>

        {loading ? (
          <div className="space-y-4">
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="bg-gray-800 p-6 rounded-lg animate-pulse">
                <div className="h-6 bg-gray-700 rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-gray-700 rounded w-full"></div>
              </div>
            ))}
          </div>
        ) : (
          <FAQ faqs={faqs} limit={6} />
        )}
      </div>
    </section>
  );
}

export default FAQSection;